import React, { useEffect, useState } from 'react'
import { Edit, SimpleForm, TextInput, useTranslate, useNotify, useRedirect, BooleanInput, required, useEditController } from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { applicationServices } from 'src/services/auth/application/application.service'
import { Skeleton } from '@mui/material'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

export const ModuleEdit = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [application, setApplication] = useState([])
  const [loading, setLoading] = useState(true)
  const { record } = useEditController({ resource: 'module', id: props.id })

  useEffect(() => {
    ;(async () => {
      if (record) {
        try {
          const allApplications = await applicationServices.getByAll()
          if (allApplications) {
            setApplication(allApplications)
            setLoading(false)
            return
          }
          notify(`applications not found`, { type: 'error' })
          setLoading(false)
        } catch (error) {
          notify(`please, refresh page`, { type: 'error' })
          setLoading(false)
        }
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  const onSuccess = () => {
    notify('ra.notification.updated_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.module') }
    })
    redirect('/module')
  }

  const onError = () => {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.module') }
    })
  }

  const transform = (data) => {
    return {
      id: data.id,
      short_name: data.short_name,
      long_name: data.long_name,
      application_id: data.application_id,
      is_active: data.is_active,
    }
  }

  return (
    <Edit
      {...props}
      transform={transform}
      mutationMode='pessimistic'
      mutationOptions={{ onSuccess, onError }}
      actions={null}
    >
      <CardCommon title={translate('ra.title.update_module')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['short_name']} genderElement='masculine' />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.short_name')} required>
              <TextInput source='short_name' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')}>
              <TextInput source='long_name' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.application')} required>
              {loading ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='application_id'
                  optionsText={['long_name']}
                  label=''
                  fullWidth
                  options={application}
                  defaultValue={record?.application_id}
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.is_active')}>
              <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
